import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import ContentfulLongText from "../ContentfulLongText";
import BlogMedia from "../BlogMedia/BlogMedia";
import Gallery from "../Gallery";
import ImageSlideShow from "../ImageSlideShow";
import ProductViewer from "../ProductViewer";
import { ContentStack } from "./ContentStack";
import { ContentSlider } from "./ContentSlider";
import { ContentColumnStack } from "./ContentColumnStack";

import './index.css';
import './content-blog-picker.css'

const ContentBlogPicker = ({ item, variant='Stack', column='3' }) => {
  if (item.contentBlogPicker !== null) {
    return (
      <div className="content-blog-picker">
        {variant === 'Column Stack' 
        ? <ContentColumnStack item={item} column={column} />
        :variant === 'Stack' 
        ? <ContentStack item={item} />
        :<ContentSlider item={item} />}
      </div>
    );
  }
  return null;
};

export const TextMedia = ({ content }) => {
  return (
    <div className={`text-media ${content.length > '1' ? 'text-media--multiple' : 'text-media--single'}`}>
      {content.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <div className={`grid ${(item.youtubeVideoLink || item.media || item.sliderMediaCollection !== null) ? 'col-2' : 'col-1 text-center'} ${item.layout === 'Text Media' ? 'layout--textmedia' : 'layout--mediatext'} gap-68 gap-15-md col-1-md mt-30 text-media-item`}>
              {item.textContent && <ContentfulLongText longTextContent={item.textContent.textContent} />}
              
              {item?.packagingView360?.images?.length > 0 ? (
                // <div></div>
                <ProductViewer packagingView360Data={item?.packagingView360} />
              ) : item.sliderMediaCollection !== null ? (
                <ImageSlideShow 
                  colorSelect={item.sliderMediaCollection.colorPicker} 
                  slides={item.sliderMediaCollection.images} 
                  hasSliderSyncing={true} 
                  isFluid={true} 
                  mediaCaption={item.mediaCaption}
                  mediaCaptionPosition={item.mediaCaptionPosition}
                  mediaCaptionColor={item.mediaCaptionColor}
                />
              ) : (
                <>
                  {(item.youtubeVideoLink !== null || item.media !== null) && (
                    <div className="relative media">
                      {item.componentTitleVisibility && <h2 className="mt-0 mb-10">{item.componentTitle}</h2>}
                      {item.youtubeVideoLink !== null ? (
                        <BlogMedia link={item.youtubeVideoLink} altText={item.mediaAltText} />
                      ):(
                        <div className="text-center">
                          <img src={item.media.gatsbyImageData.images.fallback.src} alt={item.mediaAltText || 'Media'} className="mb-0"/>
                        </div>
                      )}
                      {item.mediaCaption && (
                        <p className={`mt-0 mb-0 text-${item.mediaCaptionPosition} ${(item.mediaCaptionSize !== null && item.mediaCaptionSize !== undefined) ? `text--${item.mediaCaptionSize.toLowerCase()}` : ''}`}>
                          <span className="bold">{item.mediaCaption}</span>
                        </p>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="mt-30">
              {item.gallery && <Gallery galleryData={item.gallery} />}
            </div>
            <ContentBlogPicker item={item} variant={item.contentBlogPickerLayout} column={item.contentBlogPickerColumn ? item.contentBlogPickerColumn:3} />
          </React.Fragment>
        )
      })}
    </div>
  );
};

export const TextMediaCenter = ({ content, hasContactForm, contactFormPosition, isVisible, isRight }) => {
  return (
    <div className="text-media text-media--center">
      {content.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <div className={`grid${isVisible ? (isRight ? ' col-1-5':' col-1-4-1'):' col-1-4-1'} col-1-md gap-10 gap-15-md`}>
              <div></div>
              <div key={index} className={`text-center grid ${item.layout === 'Text Media' ? 'layout--textmedia' : 'layout--mediatext'}`}>
                {item.componentTitleVisibility && <h2 className="mt-0 mb-10 text-left">{item.componentTitle}</h2>}
                {item?.packagingView360?.images?.length > 0 ? (
                  <ProductViewer 
                    packagingView360Data={item.packagingView360} 
                  />
                ) : null}
                {item.sliderMediaCollection !== null ? (
                  <ImageSlideShow slides={item.sliderMediaCollection.images} hasSliderSyncing={true} isFluid={false} />
                ):(
                  <div className="relative media">
                    {(item.youtubeVideoLink !== null || item.media !== null) && (
                      <>
                        {item.youtubeVideoLink !== null ? (
                          <BlogMedia link={item.youtubeVideoLink} altText={item.mediaAltText} />
                        ): (
                          <div className="text-center">
                            <img src={item.media.gatsbyImageData.images.fallback.src} alt={item.mediaAltText || 'Media'} />
                          </div>
                        )}
                        {item.mediaCaption && (
                          <p className={`mt-0 mb-0 text-${item.mediaCaptionPosition} ${(item.mediaCaptionSize !== null && item.mediaCaptionSize !== undefined) ? `text--${item.mediaCaptionSize.toLowerCase()}` : ''}`}>
                            <span className="bold">{item.mediaCaption}</span>
                          </p>
                        )}
                      </>
                    )}
                  </div>
                )}
                {item.textContent && <ContentfulLongText longTextContent={item.textContent.textContent} />} 
              </div>
              <div></div>
            </div>
            {item.gallery && (
              <div className={`grid${hasContactForm ? (contactFormPosition === 'Right' ? ' col-1-5':' col-1-4-1'):' col-1-4-1'} col-1-md gap-10 gap-15-md`}>
                <div></div>
                <Gallery galleryData={item.gallery} />
                <div></div>
              </div>
            )}
            <div className={`grid${hasContactForm ? (contactFormPosition === 'Right' ? ' col-1-5':' col-1-4-1'):' col-1-4-1'} col-1-md gap-10 gap-15-md`}>
              <div></div>
              <ContentBlogPicker item={item} variant={content.contentBlogPickerLayout} />
              <div></div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
